import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";
import swal from "sweetalert";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dataProducts: [],
    detailProduct: {},
    listCart: [],
    history: [],
    dataSearch: []
  },
  mutations: {
    GET_PRODUCTS(state, payload) {
      state.dataProducts = payload;
    },
    GET_DETAIL_PRODUCT(state, payload) {
      state.detailProduct = payload.data;
      console.log(state.detailProduct, "check detail");
      router.push({ name: "DetailProduct", params: { id: payload.id } });
    },
    FIND_DATA(state, payload) {
      console.log("disini masuk kah");
      console.log(payload.data, "check", payload.payload);
      let data = payload.payload.split(" ");
      console.log(data, "ini payload");
      if (data.length === 1) {
        console.log("apakah masuk");
        const result = [];
        for (let i = 0; i < payload.data.length; i++) {
          console.log("check");
          let splitter = payload.data[i].name.split(" ");
          for (let j = 0; j < splitter.length; j++) {
            if (data[0].toLowerCase() === splitter[j].toLowerCase()) {
              console.log("checkecheck");
              result.push(payload.data[i]);
            }
          }
        }
        console.log(result, "ini result");
        state.dataSearch = result;
      } else if (data.length === 2) {
        const result = [];
        for (let i = 0; i < state.dataProducts.length; i++) {
          let splitter = state.dataProducts[i].name.split(" ");
          console.log(splitter, "ini splitter");
          if (splitter[1] !== undefined) {
            if (
              data[0].toLowerCase() === splitter[0].toLowerCase() &&
              data[1].toLowerCase() === splitter[1].toLowerCase()
            ) {
              result.push(state.dataProducts[i]);
            }
          }
        }
        console.log(result, "ini result");
        state.dataSearch = result;
      } else if (data.length === 3) {
        const result = [];
        for (let i = 0; i < state.dataProducts.length; i++) {
          let splitter = state.dataProducts[i].name.split(" ");
          if (splitter[1] !== undefined && splitter[2] !== undefined) {
            if (
              data[0].toLowerCase() === splitter[0].toLowerCase() &&
              data[1].toLowerCase() === splitter[1].toLowerCase() &&
              data[2].toLowerCase() === splitter[2].toLowerCase()
            ) {
              result.push(state.dataProducts[i]);
            }
          }
        }
        console.log(result, "ini result");
        state.dataSearch = result;
      } else if (data.length === 4) {
        const result = [];
        for (let i = 0; i < state.dataProducts.length; i++) {
          let splitter = state.dataProducts[i].name.split(" ");
          if (splitter[1] !== undefined && splitter[2] !== undefined && splitter[3] !== undefined) {
            if (
              data[0].toLowerCase() === splitter[0].toLowerCase() &&
              data[1].toLowerCase() === splitter[1].toLowerCase() &&
              data[2].toLowerCase() === splitter[2].toLowerCase() &&
              data[3].toLowerCase() === splitter[3].toLowerCase()
            ) {
              result.push(state.dataProducts[i]);
            }
          }
        }
        console.log(result, "ini result");
        state.dataSearch = result;
      }
      router.push({ name: "Search", params: { product: payload.payload } });
    },
    LIST_CART_ITEM(state, payload) {
      state.listCart = payload;
    },
    ADD_CART_ITEM(state, payload) {
      swal("Success add to cart!", "", "success");
      state.listCart.push(payload);
    },
    ADD_AND_GO_TO_CART(state, payload) {
      state.listCart.push(payload);
      router.push({ name: "CartList" });
    },
    UPDATE_CART(state, payload) {
      console.log(payload, "ini update");
      const updateCart = [];
      for (let i = 0; i < state.listCart.length; i++) {}
    },
    UPDATE_AND_GO_TO_CART(state, payload) {
      console.log(payload, "ini update");
      const updateCart = [];
      for (let i = 0; i < state.listCart.length; i++) {}
      router.push({ name: "CartList" });
    },
    DELETE_CART(state, payload) {
      const updateCart = [];
      for (let i = 0; i < state.listCart.length; i++) {
        if (state.listCart[i].id !== Number(payload)) {
          updateCart.push(state.listCart[i]);
        }
      }
      state.listCart = updateCart;
    },
    DELETE_ALL_CART(state, payload) {
      state.listCart = [];
    },
    GET_HISTORY(state, payload) {
      console.log(payload, "ini history");
      state.history = payload;
    }
  },
  actions: {
    registerUser(context, payload) {
      console.log("wkwkwk");
      const email = payload.email;
      const password = payload.password;
      const newUser = { email, password };
      axios({
        method: "POST",
        url: "https://hidden-scrubland-77425.herokuapp.com/register",
        data: newUser
      })
        .then(result => {
          swal("Success Register!", "", "success");
          console.log(result.data);
          router.push({ name: "Login" });
        })
        .catch(err => {
          swal(`${err.response.data.message[0]}`, "", "error");
          console.log(err.response.data.message);
        });
    },
    loginUser(context, payload) {
      const email = payload.email;
      const password = payload.password;
      const loginUser = { email, password };
      axios({
        method: "POST",
        url: "https://hidden-scrubland-77425.herokuapp.com/login",
        data: loginUser
      })
        .then(result => {
          console.log(result.data, "ini data");
          localStorage.access_token = result.data.access_token;
          localStorage.userId = result.data.id;
          localStorage.emailUser = result.data.email;
          swal("Success Login!", "", "success");
          router.push({ name: "Home" });
        })
        .catch(err => {
          console.log(err, "ini error");
          swal(`${err.response.data.message}`, "", "error");
          console.log(err.response.data.message[0], "erorr");
        });
    },
    readProduct(context) {
      axios({
        method: "GET",
        url: "https://hidden-scrubland-77425.herokuapp.com/products"
      })
        .then(result => {
          context.commit("GET_PRODUCTS", result.data.message);
        })
        .catch(err => {
          console.log(err.response, "ini error");
        });
    },
    searchData(context, payload) {
      console.log("check check");
      axios({
        method: "GET",
        url: "https://hidden-scrubland-77425.herokuapp.com/products"
      })
        .then(result => {
          console.log("check check 2");
          const data = result.data.message;
          console.log(data, "ini data");
          context.commit("FIND_DATA", { data, payload });
        })
        .catch(err => {
          console.log("check check 3");
          console.log(err.response, "ini error");
        });
    },
    detailProduct(context, payload) {
      console.log(payload, "detail id");
      axios({
        method: "GET",
        url: `https://hidden-scrubland-77425.herokuapp.com/products/${payload}`
      })
        .then(result => {
          const data = result.data.message;
          const id = payload;
          console.log("hehehe");
          context.commit("GET_DETAIL_PRODUCT", { data, id });
          console.log(this.$route.params.product, "check");
          // if(){
          //   this.$store.commit("FIND_DATA", this.$route.params.product);
          // }
        })
        .catch(err => {
          console.log(err.data, "ini error");
        });
    },
    async addToCart(context, payload) {
      try {
        const newCart = {
          userId: Number(localStorage.userId),
          productId: Number(payload.id),
          quantity: Number(payload.quantity)
        };
        console.log(newCart);
        console.log("hehe");
        const readData = await axios({
          method: "GET",
          url: `https://hidden-scrubland-77425.herokuapp.com/carts/`,
          headers: { access_token: localStorage.access_token },
          data: Number(localStorage.userId)
        });
        console.log(readData.data.length, "data dibaca");
        if (readData.data.length === 0) {
          console.log("papaappa");
          const newData = await axios({
            method: "POST",
            url: `https://hidden-scrubland-77425.herokuapp.com/carts/${payload.id}`,
            data: newCart,
            headers: { access_token: localStorage.access_token }
          });
          context.commit("ADD_CART_ITEM", newData.data);
        } else {
          console.log("bacabaca");
          console.log(localStorage.userId, payload.id, "data");
          const findData = [];
          for (let i = 0; i < readData.data.length; i++) {
            console.log("ll");
            console.log(
              readData.data[i].userId,
              localStorage.userId,
              "data",
              readData.data[i].productId,
              payload.id
            );
            if (
              readData.data[i].userId === Number(localStorage.userId) &&
              readData.data[i].productId === Number(payload.id)
            ) {
              console.log("hehehe");
              findData.push(readData.data[i]);
            }
          }
          console.log(findData, "ini data");
          if (findData.length === 0) {
            console.log("apakah masuk sukses");
            const newData = await axios({
              method: "POST",
              url: `https://hidden-scrubland-77425.herokuapp.com/carts/${payload.id}`,
              data: newCart,
              headers: { access_token: localStorage.access_token }
            });
            context.commit("ADD_CART_ITEM", newData.data);
          } else {
            const updateCart = {
              userId: Number(localStorage.userId),
              productId: Number(payload.id),
              quantity: Number(payload.quantity) + Number(findData[0].quantity)
            };
            console.log(updateCart, "ini update");
            const update = await axios({
              method: "PUT",
              url: `https://hidden-scrubland-77425.herokuapp.com/carts/${payload.id}`,
              data: updateCart,
              headers: { access_token: localStorage.access_token }
            });
            console.log(update.data, "ini update data");
            context.commit("UPDATE_CART", update.data);
          }
        }
      } catch (err) {
        console.log("apakah error");
        console.log(err.response);
      }
    },
    readCart(context) {
      const userId = localStorage.userId;
      axios({
        method: "GET",
        url: `https://hidden-scrubland-77425.herokuapp.com/carts/`,
        headers: { access_token: localStorage.access_token },
        data: userId
      })
        .then(result => {
          console.log(result.data);
          context.commit("LIST_CART_ITEM", result.data);
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    deleteCart(context, payload) {
      axios({
        method: "DELETE",
        url: `https://hidden-scrubland-77425.herokuapp.com/carts/deleteCart/${payload}`,
        headers: { access_token: localStorage.access_token }
      })
        .then(result => {
          console.log(result.data);
          context.commit("DELETE_CART", payload);
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    async buyItem(context, payload) {
      try {
        const newCart = {
          userId: Number(localStorage.userId),
          productId: Number(payload.id),
          quantity: Number(payload.quantity)
        };
        console.log(newCart);
        console.log("hehe");
        const readData = await axios({
          method: "GET",
          url: `https://hidden-scrubland-77425.herokuapp.com/carts/`,
          headers: { access_token: localStorage.access_token },
          data: Number(localStorage.userId)
        });
        console.log(readData.data.length, "data dibaca");
        if (readData.data.length === 0) {
          console.log("papaappa");
          const newData = await axios({
            method: "POST",
            url: `https://hidden-scrubland-77425.herokuapp.com/carts/${payload.id}`,
            data: newCart,
            headers: { access_token: localStorage.access_token }
          });
          context.commit("ADD_AND_GO_TO_CART", newData.data);
        } else {
          console.log("bacabaca");
          console.log(localStorage.userId, payload.id, "data");
          const findData = [];
          for (let i = 0; i < readData.data.length; i++) {
            console.log("ll");
            console.log(
              readData.data[i].userId,
              localStorage.userId,
              "data",
              readData.data[i].productId,
              payload.id
            );
            if (
              readData.data[i].userId === Number(localStorage.userId) &&
              readData.data[i].productId === Number(payload.id)
            ) {
              console.log("hehehe");
              findData.push(readData.data[i]);
            }
          }
          console.log(findData, "ini data");
          if (findData.length === 0) {
            console.log("apakah masuk sukses");
            const newData = await axios({
              method: "POST",
              url: `https://hidden-scrubland-77425.herokuapp.com/carts/${payload.id}`,
              data: newCart,
              headers: { access_token: localStorage.access_token }
            });
            context.commit("ADD_AND_GO_TO_CART", newData.data);
          } else {
            const updateCart = {
              userId: Number(localStorage.userId),
              productId: Number(payload.id),
              quantity: Number(payload.quantity) + Number(findData[0].quantity)
            };
            console.log(updateCart, "ini update");
            const update = await axios({
              method: "PUT",
              url: `https://hidden-scrubland-77425.herokuapp.com/carts/${payload.id}`,
              data: updateCart,
              headers: { access_token: localStorage.access_token }
            });
            console.log(update.data, "ini update data");
            context.commit("UPDATE_AND_GO_TO_CART", update.data);
          }
        }
      } catch (err) {
        console.log("apakah error");
        console.log(err.response);
      }
    },
    buyAllItem(context) {
      axios({
        method: "POST",
        url: `https://hidden-scrubland-77425.herokuapp.com/historys/${localStorage.userId}`,
        headers: { access_token: localStorage.access_token }
      })
        .then(result => {
          console.log(result);
          return axios({
            method: "DELETE",
            url: `https://hidden-scrubland-77425.herokuapp.com/carts/deleteAll`,
            headers: { access_token: localStorage.access_token }
          });
        })
        .then(result => {
          console.log(result.data);

          context.commit("DELETE_ALL_CART");
        })
        .catch(err => {
          console.log(err.response);
          console.log("ini error");
        });
    },
    getHistory(context, payload) {
      axios({
        method: "GET",
        url: `https://hidden-scrubland-77425.herokuapp.com/historys/${localStorage.userId}`,
        headers: { access_token: localStorage.access_token }
      })
        .then(result => {
          context.commit("GET_HISTORY", result.data);
        })
        .catch(err => {
          console.log(err.response);
        });
    }
  },
  modules: {}
});
